import { ApiResponse } from "@/interfaces/api-response.interface";
import { IProject, IProjectSocial, IUpdateProject, ProjectResponse } from "@/interfaces/project.interface";
import { api } from "@/lib/api/axios"
import { ProjectAbout } from "@/types/project"

const PROJECT_API_PATH = '/movie'

interface CreateProjectResponse extends ProjectAbout { }

export const projectService = {
  createProject: async (payload: ProjectAbout) => {
    const { id, ...projectData } = payload;
    return api.post<ApiResponse<CreateProjectResponse>>(`${PROJECT_API_PATH}`, projectData)
  },
  updateProject: async (payload: IUpdateProject) => {
    const { id, ...projectData } = payload;
    return api.patch(`${PROJECT_API_PATH}/${id}`, projectData)
  },
  uploadImageProject: async (payload: FormData) => {
    return api.post(`${PROJECT_API_PATH}/upload-img`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getProjects: async () => {
    return api.get<ProjectResponse>(`${PROJECT_API_PATH}`)
  },
  getProjectById: async (id: number) => {
    return api.get<IProject>(`${PROJECT_API_PATH}/${id}`)
  },
  registerSocialProject: async (payload: IProjectSocial) => {
    const { id, id_movie, ...projectData } = payload;
    return api.post(`${PROJECT_API_PATH}/${id_movie}/social`, projectData)
  },
  deleteProject: async (id: number) => {
    return api.delete(`${PROJECT_API_PATH}/${id}`)
  },
}